import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography, FormControlLabel, Checkbox } from "@mui/material";
import { GenderValue, Gender } from "@quest_editor/constants";

const GenderField = ({
  gender,
  setGender,
}: {
  gender: GenderValue[];
  setGender: React.Dispatch<React.SetStateAction<GenderValue[]>>;
}) => {
  const { t } = useTranslation("questEditor");

  const handleGenderChange =
    (key: GenderValue) =>
    (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setGender((prev: GenderValue[]) =>
        checked
          ? prev.includes(key)
            ? prev
            : [...prev, key]
          : prev.filter((g) => g !== key),
      );
    };

  return (
    <Stack direction="row" alignItems="center">
      <FormControlLabel
        control={
          <Checkbox
            checked={gender.includes(Gender.MALE)}
            onChange={handleGenderChange(Gender.MALE)}
          />
        }
        label={t("common.gender.male")}
        sx={{ color: "text.secondary" }}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={gender.includes(Gender.FEMALE)}
            onChange={handleGenderChange(Gender.FEMALE)}
          />
        }
        label={t("common.gender.female")}
        sx={{ color: "text.secondary", ml: 2 }}
      />
      <Typography color="secondary" sx={{ ml: 4 }}>
        {t("quest_edit_target.label.not_specified.note_all_target")}
      </Typography>
    </Stack>
  );
};

export default GenderField;
